// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"5c9dcca8","118":"3171faa5","191":"0d79979e","234":"dd6b19bc","395":"57fc2049","422":"0e18865a","594":"bb574ed3","629":"0cee80cc","837":"42b45333","869":"35bcd0e4"}[chunkId] + ".chunk.js";
};